<template>
  <img
    v-if="image"
    v-lazy="{ src: image }"
    class="dynamic-cover"
    :class="`dynamic-cover--${positionMap[index]}`"
    crossorigin="anonymous"
    alt=""
    width="110"
    height="146"
  />
  <PlaceholderCover
    v-else
    class="dynamic-cover"
    :class="`dynamic-cover--${positionMap[index]}`"
  />
</template>

<script setup lang="ts">
import PlaceholderCover from '@/app/components/PlaceholderCover.vue'

defineProps<{
  index: 1 | 2 | 3
  image?: string
}>()

const positionMap = {
  1: 'center',
  2: 'left',
  3: 'right',
}
</script>

<style lang="scss" setup>
.dynamic-cover {
  min-width: 0;
  filter: $shadow-f;
  --cover-width: 110px;
  @media (max-width: $w-medium-s) {
    --cover-width: 90px;
  }
}

.dynamic-cover--left,
.dynamic-cover--right {
  width: calc(var(--cover-width) * 0.75);
}

.dynamic-cover--center {
  order: 2;
  z-index: 1;
  width: var(--cover-width);
}

.dynamic-cover--left {
  order: 1;
  margin-right: calc(var(--cover-width) * -0.35);
}

.dynamic-cover--right {
  order: 3;
  margin-left: calc(var(--cover-width) * -0.35);
}
</style>
